import { restructureBookings } from "helpers/bookings";
import { apiv2QueryClient } from "../../../../apiv2QueryClient";
import { useGetPatientBookings } from "api/usePatientBookingsQuery";

export const useBookings = (patientId: number) =>
  useGetPatientBookings(
    { patientId: patientId.toString(), psychologistId: "-1" },
    { select: restructureBookings },
  );

export const invalidateBookings = () => (patientId: number | null) => {
  if (!patientId) {
    return apiv2QueryClient.invalidateQueries({
      queryKey: ["patientBookings"],
    });
  }
  return apiv2QueryClient.invalidateQueries({
    queryKey: ["patientBookings", patientId.toString()],
  });
};
